import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const AuthCheck = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/login`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Invalid username or password.",
      error: {
        code: error?.response?.status || 401,
        type: "unauthorized",
      },
    };
  }
};

export const SendOtp = async (email: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/otp/send`, { email });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to send OTP. Please try again.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ResetPassword = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/otp/reset`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to reset password. Please try again.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetUserFeatures = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/user/features`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load features.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetUsers = async (params: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/users`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load users.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const CreateUser = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/users`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create user.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const UpdateUser = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/users/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update user.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const ToggleUserStatus = async (
  id: number,
  status: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/users/status`, { id, status });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to change status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetSubFeatures = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/sub-features`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load sub features.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetUserOverrides = async (
  userId: number,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/users/overrides`, {
      params: { user_id: userId },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load overrides.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const UpdateUserOverrides = async (
  userId: number,
  overrides: any[],
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/users/overrides`, {
      user_id: userId,
      overrides,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update overrides.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetAllFeatures = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/admin/features`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load features.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetRoles = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/roles`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load roles.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
